import { EventInput } from '@fullcalendar/core';
import { IDPrefixes } from '@griply/types';
import { createCompositeId } from '@griply/utils';
import { addDays, isSameDay } from 'date-fns';
import { ExternalCalendarEvent } from 'shared/types/external-calendar-event';

export const mapExternalEventToFullCalendarEvent = (
  externalEvent: ExternalCalendarEvent,
  dayOffset?: number,
): EventInput => {
  const startDate = externalEvent.start.dateTime ?? externalEvent.start.date;
  const endDate = externalEvent.end.dateTime ?? externalEvent.end.date;
  const isMultiDay = dayOffset !== undefined;
  const isAllDay =
    isMultiDay ||
    !!externalEvent.start.date ||
    !!(
      externalEvent.start.dateTime &&
      externalEvent.end.dateTime &&
      !isSameDay(startDate, endDate)
    );

  return {
    id: isMultiDay
      ? createCompositeId(IDPrefixes.MultiDayEvent, [
          externalEvent.id,
          String(dayOffset),
        ])
      : externalEvent.id,
    title: externalEvent.title,
    date: isMultiDay ? addDays(startDate, dayOffset) : startDate,
    allDay: isAllDay,
    start: isAllDay ? undefined : startDate,
    end: isAllDay ? undefined : endDate,
    extendedProps: {
      externalId: externalEvent.id,
      url: externalEvent.url,
      color: externalEvent.color,
      name: externalEvent.title,
      ...(isMultiDay && { originalEvent: true, dayOffset }),
    },
    editable: false,
  };
};
